
































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { classTerm } from "../core/types";
import { HIGHLIGHT_THRESHOLD } from "../core/const";

@Component({
    name: "term",
    components: {},
})

export default class Term extends Vue {
    @Prop() term!: classTerm;
    @Prop() rootTerm!: string;
    @Prop({ default: true }) expandable!: boolean;
    @Prop({ default: true }) showClass!: boolean;

    expanded = false;

    mounted() {
        if (this.highlight && this.expandable) {
        this.expanded = true;
        }
    }

    get identicalToTerm() {
        return this.term && this.term.term
        ? this.term.term.trim().toLowerCase() ===
            this.rootTerm.trim().toLowerCase()
        : false;
    }

    get highlight() {
        return this.term ? Number(this.term.score) >= HIGHLIGHT_THRESHOLD : false;
    }

    get nestedTerms() {
        return this.term.classTermBag || [];
    }
}
